var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pane pane-map",class:[ _vm.app.viewlayer, {'full': !_vm.app.menuvisible, 'fil': _vm.app.view=='fil'}]},[_c('div',{staticClass:"map-content",class:{ selection: _vm.map.mode == 'selection' }},[_c('map-osm'),_c('button-report'),_c('button-adresse')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }